import { Link } from "react-router-dom";

const NotFound = () => (
  <main className="bg-white" data-testid="not-found-page">
    <div className="container-site flex min-h-[60vh] flex-col items-start justify-center py-24">
      <div className="mb-4 h-1 w-12 bg-brand-red" aria-hidden="true" />
      <p className="eyebrow">Error 404</p>
      <h1 className="mt-3 text-4xl font-semibold sm:text-5xl">Page Not Found</h1>
      <p className="mt-4 max-w-md text-base leading-relaxed text-brand-grey">
        The page you are looking for does not exist or may have been moved.
      </p>
      <Link to="/" className="btn-primary mt-8" data-testid="not-found-home-button">
        Back to Home
      </Link>
    </div>
  </main>
);

export default NotFound;
